import { Switch } from 'antd';
import styles from './index.module.sass';
import { LogisticsNotifier } from '../logistics-notifier/partners-notifier';
import { useState } from 'react';

export const LogisticsLeftbar = () => {
  const [switchState, setSwitchState] = useState(true);
  return (
    <div className={styles.root}>
      <div className={styles.topSection}>
        <h3>Транспортные компании</h3>
        {/* <div className={styles.switcher}>
          <span style={switchState ? { color: '#007E3C' } : {}}>
            {switchState
              ? 'активны для расчетов в системе'
              : 'не активны для расчетов в системе'}
          </span>
          <Switch checked={switchState} onChange={() => setSwitchState(!switchState)} />
        </div> */}
      </div>
      <div className={styles.midSection}>
        <h3>Список транспортных компаний</h3>
        <LogisticsNotifier />
      </div>
    </div>
  );
};
